
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    inject,
    signal
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DCLCardOptions } from '../../entities/dcl-card.options';
import { Store } from '@ngxs/store';
import {
    DCLCorrelationTypeQuery,
    DCLGarageUseTypeQuery,
    DCLParkingCarWashUseTypeQuery,
    DCLRentalUseTypeQuery,
    DCLResponseTypeQuery,
    DigitalClientCardGraphQLSchemaActions,
    DigitalClientCardGraphQLSchemaSelectors,
    DigitalClientCardInputType,
    DigitalClientCardType,
    DigitalClientCardTypeFormGroup,
    DigitalClientCardTypeQuery,
    ProviderResponseErrorTypeQuery,
    ResponseTypeErrorTypeQuery,
    UsersActionsTypeQuery
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';
import { concatMap, finalize, of, Subject, takeUntil } from 'rxjs';
import { LoaderService } from '@shared/services/loader.service';
import { PostDCLsToAADESchema } from '@shared/zigra-schemas/custom/PostDCLsToAADE.schema.service';

@Component({
    selector: 'zion-dcl-card-footer',
    imports: [ButtonModule],
    templateUrl: './dcl-card-footer.component.html',
    styleUrl: './dcl-card-footer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DclCardFooterComponent {
    visible?: boolean;
    cd = inject(ChangeDetectorRef);

    store = inject(Store);
    loaderService = inject(LoaderService);
    postDCLsToAADESchema = inject(PostDCLsToAADESchema);

    dialogConfig: DynamicDialogConfig<DCLCardOptions> = inject(
        DynamicDialogConfig<DCLCardOptions>
    );

    dclCard = signal<DigitalClientCardType | undefined>(undefined);

    digitalClientCardTypeFormGroup?: DigitalClientCardTypeFormGroup | undefined;

    unsubscribeSubject = new Subject<boolean>();

    /**
     *
     */
    constructor() {
        const options = this.dialogConfig.data as DCLCardOptions;
        options.onFormGroupSet = (
            digitalClientCardTypeFormGroup?: DigitalClientCardTypeFormGroup
        ) => {
            this.digitalClientCardTypeFormGroup =
                digitalClientCardTypeFormGroup;

            this.digitalClientCardTypeFormGroup?.valueChanges
                .pipe(takeUntil(this.unsubscribeSubject))
                .subscribe((value) => {
                    this.dclCard.set(value as DigitalClientCardType);
                    // we need this subscriber becuase we have to call detect changes on every form change!!!!
                    this.cd.detectChanges();
                });
        };
    }
    ngOnInit() {
        const options = this.dialogConfig.data as DCLCardOptions;

        this.dclCard.set(
            options.digitalClientCardType ?? {
                ClientServiceType: 3, // 3: Garage
                ServiceRecurring: 1,
                CreationDateTime: undefined
            }
        );
    }

    onSave() {
        const options = this.dialogConfig.data as DCLCardOptions;

        this.loaderService.showAwaitDataSaveLoader();

        const digitalClientCard =
            options.digitalClientCardTypeFormGroup?.getRawValue() as DigitalClientCardInputType;

        // Reset to undefined in case of Error Completing DCL.
        // digitalClientCard.EntryCompletion = undefined;
        this.store
            .dispatch(
                new DigitalClientCardGraphQLSchemaActions.Upsert(
                    digitalClientCard,
                    undefined,
                    digitalClientCardGQLQueryForEdit
                )
            )
            .pipe(
                // concatMap((value) => {
                //     let updatedDigitalClientCard =
                //         this.store.selectSnapshot(
                //             DigitalClientCardGraphQLSchemaSelectors.UpsertSelector(
                //                 '',
                //                 ''
                //             )
                //         )?.data.Upsert ?? digitalClientCard;

                //     // On Save Button, if it is not a new DigitalClientCard call UpdateDigitalClientCard otherwise return DigitalCLientCard
                //     if (digitalClientCard._id == undefined)
                //         return of(updatedDigitalClientCard);

                //     updatedDigitalClientCard = {
                //         ...updatedDigitalClientCard,
                //         EntryCompletion: undefined
                //     };
                //     return this.postDCLsToAADESchema.UpdateDigitalClientCard(
                //         updatedDigitalClientCard,
                //         digitalClientCardGQLQueryForEdit
                //     );
                // }),
                finalize(() => this.loaderService.dismissAwaitLoader())
            )
            .subscribe(() => {
                options.onDCLCardSave(options);
            });
    }

    sendNewClient() {
        debugger;
        const options = this.dialogConfig.data as DCLCardOptions;

        this.loaderService.showAwaitDataSaveLoader();

        const digitalClientCard =
            options.digitalClientCardTypeFormGroup?.getRawValue() as DigitalClientCardInputType;

        this.store
            .dispatch(
                new DigitalClientCardGraphQLSchemaActions.Upsert(
                    digitalClientCard,
                    undefined,
                    digitalClientCardGQLQueryForEdit
                )
            )
            .pipe(
                concatMap(() => {
                    let updatedDigitalClientCard =
                        this.store.selectSnapshot(
                            DigitalClientCardGraphQLSchemaSelectors.UpsertSelector(
                                '',
                                ''
                            )
                        )?.data.Upsert ?? digitalClientCard;
                    return this.postDCLsToAADESchema.NewDigitalClientCard(
                        updatedDigitalClientCard,
                        digitalClientCardGQLQueryForEdit
                    );
                }),
                finalize(() => this.loaderService.dismissAwaitLoader())
            )
            // .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
            .subscribe(() => {
                options.onDCLCardSave(options);
            });

        // this.postDCLsToAADESchema
        //     .NewDigitalClientCard(
        //         digitalClientCard,
        //         DigitalClientCardTypeQuery.GQLQuery()
        //     )
        //     .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
        //     .subscribe(() => {
        //         options.onSave(options);
        //     });
    }

    // completeDCL() {
    //     const options = this.dialogConfig as DCLCardOptions;

    //     this.loaderService.showAwaitDataSaveLoader();

    //     const digitalClientCard =
    //         options.digitalClientCardTypeFormGroup?.getRawValue() as DigitalClientCardInputType;

    //     digitalClientCard.EntryCompletion = true;

    //     this.store
    //         .dispatch(
    //             new DigitalClientCardGraphQLSchemaActions.Upsert(
    //                 digitalClientCard,
    //                 undefined,
    //                 digitalClientCardGQLQueryForEdit
    //             )
    //         )
    //         .pipe(
    //             concatMap(() => {
    //                 let updatedDigitalClientCard =
    //                     this.store.selectSnapshot(
    //                         DigitalClientCardGraphQLSchemaSelectors.UpsertSelector(
    //                             '',
    //                             ''
    //                         )
    //                     )?.data.Upsert ?? digitalClientCard;

    //                 return this.postDCLsToAADESchema
    //                     .CorrelateDigitalClientCard(
    //                         updatedDigitalClientCard,
    //                         undefined,
    //                         digitalClientCardGQLQueryForEdit
    //                     )
    //                     .pipe(
    //                         concatMap(() => {
    //                             debugger;

    //                             return this.postDCLsToAADESchema.UpdateDigitalClientCard(
    //                                 updatedDigitalClientCard,
    //                                 digitalClientCardGQLQueryForEdit
    //                             );
    //                         })
    //                     );
    //             }),
    //             finalize(() => this.loaderService.dismissAwaitLoader())
    //         )
    //         // .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
    //         .subscribe(() => {
    //             options.onSave(options);
    //         });

    //     // this.postDCLsToAADESchema
    //     //     .CorrelateDigitalClientCard(
    //     //         digitalClientCard,
    //     //         DigitalClientCardTypeQuery.GQLQuery()
    //     //     )
    //     //     .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
    //     //     .subscribe(() => {
    //     //         options.onSave(options);
    //     //     });
    // }

    ngOnDestroy() {
        this.unsubscribeSubject.next(true);
        this.unsubscribeSubject.complete();
    }
}

const digitalClientCardGQLQueryForEdit = DigitalClientCardTypeQuery.GQLQuery({
    Garage: DCLGarageUseTypeQuery.GQLQuery(),
    RentalUse: DCLRentalUseTypeQuery.GQLQuery(),
    ParkingUse: DCLParkingCarWashUseTypeQuery.GQLQuery(),
    Responses: DCLResponseTypeQuery.GQLQuery({
        Errors: ResponseTypeErrorTypeQuery.GQLQuery({
            Error: ProviderResponseErrorTypeQuery.GQLQuery()
        }),
        DCLCorrelations: DCLCorrelationTypeQuery.GQLQuery(),
        UsersActions: UsersActionsTypeQuery.GQLQuery()
    })
});
